"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var OrdersApi = /** @class */ (function (_super) {
    __extends(OrdersApi, _super);
    function OrdersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Use this endpoint to attach a posting room to an order.
     * Attach a posting room from an order
     */
    OrdersApi.prototype.actionAttachPostingRoomToOrderRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling actionAttachPostingRoomToOrder.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/orders/{orderId}/posting-room".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.PostingRoomToOrderToJSON(requestParameters.postingRoomToOrder),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowPostingRoomFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to attach a posting room to an order.
     * Attach a posting room from an order
     */
    OrdersApi.prototype.actionAttachPostingRoomToOrder = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionAttachPostingRoomToOrderRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to detach a posting room to an order.
     * Detach a posting room from an order
     */
    OrdersApi.prototype.actionDetachPostingRoomToOrderRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling actionDetachPostingRoomToOrder.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/orders/{orderId}/posting-room".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Use this endpoint to detach a posting room to an order.
     * Detach a posting room from an order
     */
    OrdersApi.prototype.actionDetachPostingRoomToOrder = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionDetachPostingRoomToOrderRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Use this endpoint to print a summary of the given order to an Esc/Pos printer connected to Trybe via a [`EscPosConnector`](/endpoints/shop/esc-pos-connectors/#createEscPosConnector).
     * Print POS receipt
     */
    OrdersApi.prototype.actionPrintPosReceiptForOrderRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling actionPrintPosReceiptForOrder.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/orders/{orderId}/print-pos-receipt".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.PrintPosReceiptForOrderToJSON(requestParameters.printPosReceiptForOrder),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowOrderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to print a summary of the given order to an Esc/Pos printer connected to Trybe via a [`EscPosConnector`](/endpoints/shop/esc-pos-connectors/#createEscPosConnector).
     * Print POS receipt
     */
    OrdersApi.prototype.actionPrintPosReceiptForOrder = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionPrintPosReceiptForOrderRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to apply the discount from a [`DiscountType`](/endpoints/DiscountTypes) to an order.
     * Apply a discount to an order
     */
    OrdersApi.prototype.createDiscountForOrderRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling createDiscountForOrder.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/orders/{orderId}/discounts".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ApplyDiscountToOrderToJSON(requestParameters.applyDiscountToOrder),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ApplyOrderDiscountFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to apply the discount from a [`DiscountType`](/endpoints/DiscountTypes) to an order.
     * Apply a discount to an order
     */
    OrdersApi.prototype.createDiscountForOrder = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createDiscountForOrderRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to apply the discount from a [`DiscountType`](/endpoints/DiscountTypes) to an order item.
     * Apply a discount to an order item
     */
    OrdersApi.prototype.createDiscountForOrderItemRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling createDiscountForOrderItem.');
                        }
                        if (requestParameters.itemId === null || requestParameters.itemId === undefined) {
                            throw new runtime.RequiredError('itemId', 'Required parameter requestParameters.itemId was null or undefined when calling createDiscountForOrderItem.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/orders/{orderId}/items/{itemId}/discounts".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))).replace("{" + "itemId" + "}", encodeURIComponent(String(requestParameters.itemId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ApplyDiscountToOrderItemToJSON(requestParameters.applyDiscountToOrderItem),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ApplyOrderItemDiscountFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to apply the discount from a [`DiscountType`](/endpoints/DiscountTypes) to an order item.
     * Apply a discount to an order item
     */
    OrdersApi.prototype.createDiscountForOrderItem = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createDiscountForOrderItemRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This endpoint sends an SMS message to a customer.
     * Send an SMS message
     */
    OrdersApi.prototype.createSmsMessageRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling createSmsMessage.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/orders/{orderId}/sms".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.SendSmsMessageToJSON(requestParameters.sendSmsMessage),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowSmsMessageFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint sends an SMS message to a customer.
     * Send an SMS message
     */
    OrdersApi.prototype.createSmsMessage = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createSmsMessageRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This endpoint previews an SMS message for an order.
     * Preview an SMS message for an order
     */
    OrdersApi.prototype.createSmsMessagePreviewRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling createSmsMessagePreview.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/orders/{orderId}/sms/preview".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.PreviewSmsMessageToJSON(requestParameters.previewSmsMessage),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.PreviewSmsMessage1FromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint previews an SMS message for an order.
     * Preview an SMS message for an order
     */
    OrdersApi.prototype.createSmsMessagePreview = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createSmsMessagePreviewRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This endpoint allows you to stop or start a scheduled follow-up or reminder SMS message from being sent for an order.
     * Manage SMS suppression for an order
     */
    OrdersApi.prototype.createSmsMessageSuppressionRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling createSmsMessageSuppression.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/orders/{orderId}/sms/suppress".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.SuppressSmsMessageToJSON(requestParameters.suppressSmsMessage),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * This endpoint allows you to stop or start a scheduled follow-up or reminder SMS message from being sent for an order.
     * Manage SMS suppression for an order
     */
    OrdersApi.prototype.createSmsMessageSuppression = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createSmsMessageSuppressionRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * This endpoint deletes a `Discount` by ID from an order item.
     * Remove a discount from an order item
     */
    OrdersApi.prototype.deleteItemDiscountRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling deleteItemDiscount.');
                        }
                        if (requestParameters.itemId === null || requestParameters.itemId === undefined) {
                            throw new runtime.RequiredError('itemId', 'Required parameter requestParameters.itemId was null or undefined when calling deleteItemDiscount.');
                        }
                        if (requestParameters.discountId === null || requestParameters.discountId === undefined) {
                            throw new runtime.RequiredError('discountId', 'Required parameter requestParameters.discountId was null or undefined when calling deleteItemDiscount.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/orders/{orderId}/items/{itemId}/discounts/{discountId}".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))).replace("{" + "itemId" + "}", encodeURIComponent(String(requestParameters.itemId))).replace("{" + "discountId" + "}", encodeURIComponent(String(requestParameters.discountId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * This endpoint deletes a `Discount` by ID from an order item.
     * Remove a discount from an order item
     */
    OrdersApi.prototype.deleteItemDiscount = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteItemDiscountRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * This endpoint deletes a `Discount` by ID from an order.
     * Remove a discount from an order
     */
    OrdersApi.prototype.deleteOrderDiscountRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling deleteOrderDiscount.');
                        }
                        if (requestParameters.discountId === null || requestParameters.discountId === undefined) {
                            throw new runtime.RequiredError('discountId', 'Required parameter requestParameters.discountId was null or undefined when calling deleteOrderDiscount.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/orders/{orderId}/discounts/{discountId}".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))).replace("{" + "discountId" + "}", encodeURIComponent(String(requestParameters.discountId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * This endpoint deletes a `Discount` by ID from an order.
     * Remove a discount from an order
     */
    OrdersApi.prototype.deleteOrderDiscount = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteOrderDiscountRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Use this endpoint to remove the applied [`DiscountType`](/endpoints/DiscountTypes), when it is a promo code, from an order, as well as its associated discounts.
     * Remove promo code
     */
    OrdersApi.prototype.deletePromoCodeFromOrderRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling deletePromoCodeFromOrder.');
                        }
                        if (requestParameters.discountTypeId === null || requestParameters.discountTypeId === undefined) {
                            throw new runtime.RequiredError('discountTypeId', 'Required parameter requestParameters.discountTypeId was null or undefined when calling deletePromoCodeFromOrder.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/orders/{orderId}/remove-promo-code/{discountTypeId}".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))).replace("{" + "discountTypeId" + "}", encodeURIComponent(String(requestParameters.discountTypeId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Use this endpoint to remove the applied [`DiscountType`](/endpoints/DiscountTypes), when it is a promo code, from an order, as well as its associated discounts.
     * Remove promo code
     */
    OrdersApi.prototype.deletePromoCodeFromOrder = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deletePromoCodeFromOrderRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * This endpoint deletes an SMS message relating to an order.
     * Delete an SMS message
     */
    OrdersApi.prototype.deleteSmsMessageRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling deleteSmsMessage.');
                        }
                        if (requestParameters.smsId === null || requestParameters.smsId === undefined) {
                            throw new runtime.RequiredError('smsId', 'Required parameter requestParameters.smsId was null or undefined when calling deleteSmsMessage.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/orders/{orderId}/sms/{smsId}".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))).replace("{" + "smsId" + "}", encodeURIComponent(String(requestParameters.smsId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * This endpoint deletes an SMS message relating to an order.
     * Delete an SMS message
     */
    OrdersApi.prototype.deleteSmsMessage = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteSmsMessageRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * This endpoint retrieves the date for when the next automated order message will be sent. This includes reminder and follow-up messages.
     * Retrieve the date which the next automated order message will be sent at
     */
    OrdersApi.prototype.getNextAutomatedOrderMessageRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling getNextAutomatedOrderMessage.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/orders/{orderId}/automated-order-messages".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.GetNextAutomatedOrderMessageFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint retrieves the date for when the next automated order message will be sent. This includes reminder and follow-up messages.
     * Retrieve the date which the next automated order message will be sent at
     */
    OrdersApi.prototype.getNextAutomatedOrderMessage = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getNextAutomatedOrderMessageRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This endpoint retrieves a single SMS message relating to an order.
     * Get a single SMS message
     */
    OrdersApi.prototype.getSmsMessageRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling getSmsMessage.');
                        }
                        if (requestParameters.smsId === null || requestParameters.smsId === undefined) {
                            throw new runtime.RequiredError('smsId', 'Required parameter requestParameters.smsId was null or undefined when calling getSmsMessage.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/orders/{orderId}/sms/{smsId}".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))).replace("{" + "smsId" + "}", encodeURIComponent(String(requestParameters.smsId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowSmsMessageFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint retrieves a single SMS message relating to an order.
     * Get a single SMS message
     */
    OrdersApi.prototype.getSmsMessage = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSmsMessageRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This endpoint retrieves the suppression status of a scheduled follow-up or reminder SMS message for an order.
     * Retrieve the suppression status of an SMS message for an order
     */
    OrdersApi.prototype.getSmsMessageSuppressionStatusRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling getSmsMessageSuppressionStatus.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/orders/{orderId}/sms/suppress".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowSmsMessageSuppressionStatusFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint retrieves the suppression status of a scheduled follow-up or reminder SMS message for an order.
     * Retrieve the suppression status of an SMS message for an order
     */
    OrdersApi.prototype.getSmsMessageSuppressionStatus = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSmsMessageSuppressionStatusRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve all fiscal receipts attached to an order.
     * Retrieve all fiscal receipts attached to an order.
     */
    OrdersApi.prototype.listOrderFiscalReceiptsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling listOrderFiscalReceipts.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/orders/{orderId}/fiscal-receipts".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.OrderFiscalReceiptsFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieve all fiscal receipts attached to an order.
     * Retrieve all fiscal receipts attached to an order.
     */
    OrdersApi.prototype.listOrderFiscalReceipts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listOrderFiscalReceiptsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This endpoint retrieves all the SMS messages and emails relating to an order.
     * List order messages
     */
    OrdersApi.prototype.listOrderMessagesRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling listOrderMessages.');
                        }
                        queryParameters = {};
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.perPage !== undefined) {
                            queryParameters['per_page'] = requestParameters.perPage;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/orders/{orderId}/order-messages".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ListOrderMessagesFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint retrieves all the SMS messages and emails relating to an order.
     * List order messages
     */
    OrdersApi.prototype.listOrderMessages = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listOrderMessagesRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This endpoint retrieves all the SMS messages relating to an order.
     * List SMS messages
     */
    OrdersApi.prototype.listSmsMessagesRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling listSmsMessages.');
                        }
                        queryParameters = {};
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.perPage !== undefined) {
                            queryParameters['per_page'] = requestParameters.perPage;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/orders/{orderId}/sms".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ListSmsMessagesFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint retrieves all the SMS messages relating to an order.
     * List SMS messages
     */
    OrdersApi.prototype.listSmsMessages = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listSmsMessagesRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to update the \'sold by\' (commission) attribute for an order item.
     * Update the \'sold by\' staff member for an item
     */
    OrdersApi.prototype.updateItemSoldByRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling updateItemSoldBy.');
                        }
                        if (requestParameters.itemId === null || requestParameters.itemId === undefined) {
                            throw new runtime.RequiredError('itemId', 'Required parameter requestParameters.itemId was null or undefined when calling updateItemSoldBy.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/orders/{orderId}/items/{itemId}/sold-by".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))).replace("{" + "itemId" + "}", encodeURIComponent(String(requestParameters.itemId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.UpdateItemSoldByToJSON(requestParameters.updateItemSoldBy),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowOrder1FromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to update the \'sold by\' (commission) attribute for an order item.
     * Update the \'sold by\' staff member for an item
     */
    OrdersApi.prototype.updateItemSoldBy = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateItemSoldByRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to replace all labels on an order with the given values.
     * Update the labels on an order
     */
    OrdersApi.prototype.updateOrderLabelsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling updateOrderLabels.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/orders/{orderId}/labels".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.UpdateOrderLabelsToJSON(requestParameters.updateOrderLabels),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowOrderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to replace all labels on an order with the given values.
     * Update the labels on an order
     */
    OrdersApi.prototype.updateOrderLabels = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateOrderLabelsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to update the service charge applied to an order.
     * Update the service charge on an order
     */
    OrdersApi.prototype.updateOrderServiceChargeRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling updateOrderServiceCharge.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/orders/{orderId}/service-charge".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.UpdateOrderServiceChargeToJSON(requestParameters.updateOrderServiceCharge),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowOrderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to update the service charge applied to an order.
     * Update the service charge on an order
     */
    OrdersApi.prototype.updateOrderServiceCharge = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateOrderServiceChargeRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to update the tip applied to an order.
     * Update the tip on an order
     */
    OrdersApi.prototype.updateOrderTipRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling updateOrderTip.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/orders/{orderId}/tip".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.UpdateOrderTipToJSON(requestParameters.updateOrderTip),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowOrderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to update the tip applied to an order.
     * Update the tip on an order
     */
    OrdersApi.prototype.updateOrderTip = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateOrderTipRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return OrdersApi;
}(runtime.BaseAPI));
exports.OrdersApi = OrdersApi;
